import { Link } from "react-router-dom";
import { motion } from "motion/react";
import Header from "../../components/feature/Header";
import Footer from "../../components/feature/Footer";
import WhatsAppFloating from "../../components/feature/WhatsAppFloating";
import CookieBanner from "../../components/feature/CookieBanner";
import SEO from "../../components/feature/SEO";

export default function Gracias() {
  return (
    <div className="min-h-screen bg-white">
      <SEO
        title="Gracias | Persianas Toldos Málaga"
        description="Gracias por contactarnos. Te respondemos en menos de 24h con tu presupuesto."
        ogImage="https://persianas-toldos-malaga.es/og/og-default.jpg"
        ogType="website"
        robots="noindex, nofollow"
      />
      <Header />
      <main className="pt-24 md:pt-[72px]">
        {/* HERO CENTRADO */}
        <section className="bg-surface-alt py-20 md:py-32">
          <div className="max-w-container mx-auto px-4 md:px-6 text-center">
            <motion.div
              initial={{ scale: 0.5, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              transition={{ duration: 0.5, type: "spring" }}
              className="w-20 h-20 md:w-24 md:h-24 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-8"
            >
              <svg
                className="w-10 h-10 md:w-12 md:h-12 text-green-500"
                fill="none"
                stroke="currentColor"
                strokeWidth="3"
                viewBox="0 0 24 24"
                aria-hidden="true"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M5 13l4 4L19 7"
                />
              </svg>
            </motion.div>

            <motion.h1
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.2 }}
              className="font-heading font-extrabold text-3xl md:text-5xl text-text-primary mb-5 leading-tight"
            >
              ¡Mensaje recibido!
            </motion.h1>

            <motion.p
              initial={{ opacity: 0, y: 12 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.35 }}
              className="font-body text-lg text-text-secondary max-w-xl mx-auto mb-10"
            >
              Gracias por contactarnos. Te respondemos en menos de 24h con tu presupuesto.
            </motion.p>

            <motion.div
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.5 }}
            >
              <Link
                to="/"
                className="inline-flex items-center gap-2 bg-primary hover:bg-primary-dark text-white font-body font-bold text-lg px-8 py-4 rounded-pill transition-colors whitespace-nowrap"
              >
                Volver al inicio <span aria-hidden="true">→</span>
              </Link>
            </motion.div>
          </div>
        </section>

        {/* MIENTRAS TANTO... */}
        <section className="py-16 md:py-24">
          <div className="max-w-container mx-auto px-4 md:px-6">
            <h2 className="font-heading font-extrabold text-2xl md:text-3xl text-text-primary text-center mb-10">
              Mientras tanto...
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-4xl mx-auto">
              <motion.a
                href="tel:+34951120770"
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.4, delay: 0 }}
                className="flex flex-col items-center gap-4 p-6 md:p-8 bg-white border border-border rounded-2xl hover:border-primary transition-colors text-center"
              >
                <div className="w-12 h-12 bg-primary/10 text-primary rounded-full flex items-center justify-center text-2xl shrink-0">
                  <span aria-hidden="true">📞</span>
                </div>
                <div>
                  <h3 className="font-heading font-bold text-lg text-text-primary mb-1">
                    ¿Es urgente?
                  </h3>
                  <p className="font-body text-sm text-text-secondary">
                    Llámanos al{" "}
                    <span className="font-bold text-primary">951 12 07 70</span>
                  </p>
                </div>
              </motion.a>

              <motion.a
                href="https://wa.me/34627213347?text=Hola%2C%20me%20interesa%20info"
                target="_blank"
                rel="noopener noreferrer"
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.4, delay: 0.1 }}
                className="flex flex-col items-center gap-4 p-6 md:p-8 bg-white border border-border rounded-2xl hover:border-whatsapp transition-colors text-center"
              >
                <div className="w-12 h-12 bg-whatsapp/10 text-whatsapp rounded-full flex items-center justify-center shrink-0">
                  <i className="ri-whatsapp-line text-2xl" aria-hidden="true"></i>
                </div>
                <div>
                  <h3 className="font-heading font-bold text-lg text-text-primary mb-1">
                    Chatea por WhatsApp
                  </h3>
                  <p className="font-body text-sm text-text-secondary">
                    <span className="font-bold text-whatsapp">627 21 33 47</span>
                  </p>
                </div>
              </motion.a>

              <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.4, delay: 0.2 }}
                className="flex flex-col items-center gap-4 p-6 md:p-8 bg-white border border-border rounded-2xl text-center"
              >
                <div className="w-12 h-12 bg-accent/10 text-accent rounded-full flex items-center justify-center text-2xl shrink-0">
                  <span aria-hidden="true">📍</span>
                </div>
                <div>
                  <h3 className="font-heading font-bold text-lg text-text-primary mb-1">
                    Visita nuestro taller
                  </h3>
                  <p className="font-body text-sm text-text-secondary">
                    Calle Pacífico 54
                    <br />
                    San Andrés, 29003 Málaga
                  </p>
                </div>
              </motion.div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
      <WhatsAppFloating />
      <CookieBanner />
    </div>
  );
}